import React from "react";
import { ShieldWarning } from "@phosphor-icons/react";

/**
 * SensitiveDataHint — a small, consistent privacy reminder shown under every
 * chat composer in the portal (main chat, welcome screen, geospatial chat,
 * dashboard-builder chat). Reminds users not to paste passwords or sensitive
 * personal information into a chat that may be logged/processed.
 *
 * Inline-styled on purpose so it drops cleanly into surfaces using different
 * styling systems (Fluent mergeStyleSets vs inline). Muted text with an amber
 * shield so it reads as a gentle-but-visible caution, not an alarm.
 */
interface Props {
  style?: React.CSSProperties;
  align?: "left" | "center";
}

export default function SensitiveDataHint({ style, align = "center" }: Props) {
  return (
    <div
      role="note"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: align === "center" ? "center" : "flex-start",
        gap: 6,
        fontSize: 11,
        lineHeight: 1.4,
        color: "#747474",
        ...style,
      }}
    >
      <ShieldWarning
        size={13}
        weight="regular"
        style={{ flexShrink: 0, color: "#9C6B00" }}
        aria-hidden="true"
      />
      <span>Avoid entering passwords or personal, sensitive information in this chat.</span>
    </div>
  );
}
